import { createStandardMenuItems, Menu } from "@msuite/ui/menu";
import { type CellContext, RowActionsWrapper } from "@msuite/ui/table";
import type { OrderFormSchema } from "@msuite/utils/schemas";
import type { ArticleListItem } from "@msuite/utils/types";
import { useFormContext } from "react-hook-form";

export function RowActions({ cell }: CellContext<ArticleListItem, "actions">) {
	/** Hooks */
	const methods = useFormContext<OrderFormSchema>();

	/** Functions */
	function handleOnRemove() {
		const articles = methods.getValues("articles");
		const newArticles = articles.filter((article) => article.articleId !== cell.row.id);
		methods.setValue("articles", newArticles);
	}

	/** Render */
	return (
		<RowActionsWrapper to={null}>
			<Menu
				items={createStandardMenuItems({
					onDelete: handleOnRemove,
				})}
			>
				<Menu.Button />
			</Menu>
		</RowActionsWrapper>
	);
}
